import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./NotFound.scss";
import FixedFooter from "../../components/FixedFooter/FixedFooter";
import PrimaryActionButton from "../../components/Buttons/PrimaryActionButton/PrimaryActionButton";
import FilledButton, {
  ButtonSizes,
} from "../../components/dashboard-page/FilledButton/FilledButton";
import GameThumbnailsHero from "../../components/GameThumbnailsHero/GameThumbnailsHero";
import { ROUTES } from "../../utils/constants";
import {
  extractOgTitleFromMainTitle,
  renderHeaders,
} from "../../utils/renderHeaders";

function NotFound() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      {renderHeaders({
        title: t("metadata:sigma_page_not_found_title"),
        description: t("metadata:sigma_page_not_found_description"),
        ogTitle: extractOgTitleFromMainTitle(
          t("metadata:sigma_page_not_found_title")
        ),
      })}
      <main className="not-found-page MobileOnly">
        <GameThumbnailsHero />
        <section className="pt-5 px-3">
          <h1 className="mb-2">{t("not_found.youre_off_the_map")}</h1>
          <p>
            {t("not_found.looks_like_this_link_is_broken")}
            <br />
            {t("not_found.lets_get_you_back_in_the_game")}
          </p>
          <FixedFooter className="px-3">
            <PrimaryActionButton
              text={t("not_found.explore_games")}
              onClick={() => navigate(ROUTES.GAMES.ROOT)}
            />
            <FilledButton
              fullwidth
              size={ButtonSizes.MD}
              className="mt-3 go-home-btn"
              onClick={() => navigate(ROUTES.ROOT.HOME)}
            >
              <span>{t("not_found.go_home")}</span>
            </FilledButton>
          </FixedFooter>
        </section>
      </main>
    </>
  );
}

export default NotFound;
